import { forwardRef } from 'react';
import './Popup.styles.css';
import { PinionManIcon, PinionManVariants } from '../../UI';

interface PopupProps {
  likes: number;
  dislikes: number;
}

export const Popup = forwardRef<HTMLDivElement, PopupProps>((props, ref) => {

  const { likes, dislikes } = props;

  return (
    <div className='voting-bar-popup-container'>
      <div ref={ref} className="voting-bar-popup">
        <div className='flex'>
          <PinionManIcon variant={PinionManVariants.SMALL_ONE} color={'orange'} />
          <span className='votes-count'>{likes.toString()}</span>
        </div>
        <div className='flex'>
          <PinionManIcon variant={PinionManVariants.SMALL_ONE} color={'purple'} />
          <span className='votes-count'>{dislikes.toString()}</span>
        </div>
      </div>
    </div>
  );
});
